import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAlerts } from '@store/selectors/alerts.selector';
import { selectUserState } from '@store/selectors/user.selector';
import { Message } from 'primeng/api';
import { MessagesModule } from 'primeng/messages';

@Component({
  standalone: true,
  imports: [MessagesModule],
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
})
export class AlertsComponent implements OnInit {
  msgs!: Message[];

  user$ = this.store.select(selectUserState);

  constructor(private readonly store: Store) {}

  ngOnInit() {
    /**
     * It is required that the user is shown all persistent alerts.
     * gets and saves all alerts
     */

    this.store.select(selectAlerts).subscribe((alerts) => {
      this.msgs = alerts.map((msg) => {
        return {
          severity: msg.type.toLowerCase(),
          detail: msg.description,
          id: msg.id,
        };
      });

      return [];
    });
  }
}
